var Ractive = require('ractive');
var component = module;

	component.exports = {
		onrender: function (options) {
			var self = this;

		},
		data: function () {
			return {
				Title: "",
				Description: "",
				Lng: SiteLng
			}
		}
	}

component.exports.template = {v:4,t:[{p:[1,1,0],t:7,e:"div",m:[{n:"style",f:"width: 100%;",t:13}],f:[{p:[2,2,29],t:7,e:"div",m:[{n:"class",f:"text-center",t:13},{n:"style",f:"display: table; margin: 0 auto;",t:13}],f:[{p:[3,3,98],t:7,e:"i",m:[{n:"class",f:"fa fa-circle-o-notch fa-spin",t:13},{n:"style",f:"font-size:48px",t:13}]}," ",{t:8,r:"content",p:[4,3,169]}," ",{p:[5,3,185],t:7,e:"h2",f:[{t:3,r:"Title",p:[5,7,189]}]}," ",{p:[6,3,209],t:7,e:"p",f:[{t:3,r:"Description",p:[6,6,212]}]}]}]}]};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Element/Wait.html
// module id = 17
// module chunks = 0